
import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { getShiftsStopsFromScenarios } from '../libs/getShiftsStopsFromScenarios'
import { Scenario } from '../models/planning/Scenario'
import { replaceAllPlanningShifts, upsertMultiplePlanningShifts } from '../slices/planningShiftsSlice'
import { replaceAllPlanningStops, upsertMultiplePlanningStops } from '../slices/planningStopsSlice'
import { replaceAllScenarios, upsertMultipleScenarios } from '../slices/scenariosSlice'

type FetchScenarioPayload = {
  scenarioIds?: EntityId[] // If scenarioIds is [], the API will return all scenarios
}

// If scenarioIds array is empty, fetch all scenarios
export const fetchScenarios = createAsyncThunk('scenarios/fetch', async ({ scenarioIds = [] }: FetchScenarioPayload, { dispatch }) => {
  const scenarios = await OLMSApiService.post<Scenario[]>('/planning/ScenarioList', scenarioIds.filter(item => item !== null && item !== undefined))

  // To normalize data and preserve data integrity, separate shifts and scenarios before updating store
  if (scenarios && scenarios.length >= 0) {
    const { shifts, stops } = getShiftsStopsFromScenarios(scenarios)

    if (scenarioIds.length === 0) {
      dispatch(replaceAllPlanningShifts(shifts))
      dispatch(replaceAllPlanningStops(stops))
    } else {
      dispatch(upsertMultiplePlanningShifts(shifts))
      dispatch(upsertMultiplePlanningStops(stops))
    }

    const scenariosWithoutShifts = scenarios.map(scenario => {
      const { shifts: excludedShifts, ...rest } = scenario

      return rest
    })

    if (scenarioIds.length === 0) {
      dispatch(replaceAllScenarios(scenariosWithoutShifts))
    } else {
      dispatch(upsertMultipleScenarios(scenariosWithoutShifts))
    }
  }

  return scenarios
})
